import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  sessionTime: 300000,
};

const slice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    changeTime(state, action) {
      const { timeObj } = action.payload;
      if(timeObj.span=='min')
      {
          state.sessionTime=timeObj.value * 1000 * 60
      }
      else{
        state.sessionTime=timeObj.value * 1000 * 60 * 60
      }
    },
  }
});

export const reducer = slice.reducer;

export const sessionDuration = (payload) => (dispatch) => {
  dispatch(slice.actions.changeTime({timeObj:payload }));
};

